'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineSummaryEditor = require('./components/InlineSummaryEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineSummaryEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/inline-summary-editor/index.js
// module id = 1028
// module chunks = 4